module.exports = __webpack_public_path__ + "img/2.45e92e6d.jpg";